import React, { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  padding?: number;
  style?: React.CSSProperties;
}

export const Card: React.FC<Props> = ({ children, padding = 20, style }) => (
  <div
    style={{
      background: 'var(--bg-card)',
      border: '1px solid var(--border)',
      borderRadius: 'var(--radius-lg)',
      boxShadow: 'var(--shadow-sm)',
      padding,
      ...style,
    }}
  >
    {children}
  </div>
);
